import {
    apiRequest,
    templateSuratDetail
} from "../../../../../services/adapters/master/templateSuratService.jsx"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", templateSuratDetail, {
            params: query
        }, true)
    }

}

export default DetailRepository
